export default __webpack_public_path__ + "static/media/Miranda_9781408344095.23cf52cc.jpg";